import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


import type { Livro } from "@/types/livro"

export type ProgressServiceKey = 'livro' | 'capa' | 'amazon' | 'isbn' | 'traducao'
export interface ProgressServiceStep {
  key: ProgressServiceKey
  label: string
  done: boolean
}

export type StatusByKey = Record<ProgressServiceKey, boolean>

export function reorderServicesForProgress(livro: Livro): { orderedServices: ProgressServiceStep[]; percent: number; statusByKey: StatusByKey } {
  const services = livro.services ?? {}
  const isDelivered = !!livro.status_entrega
  const doneLivro = Boolean(isDelivered || services.livro)

  const baseSteps: ProgressServiceStep[] = [
    { key: 'livro', label: 'Lançamento', done: doneLivro },
    { key: 'capa', label: 'Capa Personalizada', done: !!services.capa },
    { key: 'amazon', label: 'Publicação Amazon', done: !!services.amazon },
    { key: 'isbn', label: 'Registro ISBN', done: !!services.isbn },
    { key: 'traducao', label: 'Tradução', done: !!services.traducao },
  ]

  // Preserve logical order within groups using the base order above
  const stepMap = new Map(baseSteps.map(s => [s.key, s]))
  const order: ProgressServiceKey[] = ['livro', 'capa', 'amazon', 'isbn', 'traducao']

  const others = order.filter(k => k !== 'livro').map(k => stepMap.get(k)!)
  const completed = others.filter(s => s.done)
  const incomplete = others.filter(s => !s.done)

  // Always place "Lançamento" first if delivered; otherwise include it among incomplete
  let orderedServices: ProgressServiceStep[]
  if (isDelivered) {
    orderedServices = [stepMap.get('livro')!, ...completed, ...incomplete]
  } else {
    orderedServices = [...completed, stepMap.get('livro')!, ...incomplete]
  }

  const percent = Math.round((baseSteps.filter(s => s.done).length / baseSteps.length) * 100)

  const statusByKey: StatusByKey = {
    livro: doneLivro,
    capa: !!services.capa,
    amazon: !!services.amazon,
    isbn: !!services.isbn,
    traducao: !!services.traducao,
  }

  return { orderedServices, percent, statusByKey }
}
